import React from 'react';
import { useTranslation } from 'react-i18next';
import useApiGet from '../../hooks/useApiGet';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faRotate, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import CountryItem from './CountryItem';
import './CountryList.css';

const CountryList = () => {
    const { t } = useTranslation();
    const [ data, error, isLoading ] = useApiGet({ method: '/countries' });

    if(isLoading || error) return (<div>
        <h1>{t('country.title_list')}</h1>
        {isLoading && <div className='success'>
            <Icon icon={faRotate} className='fa-spin'/>&nbsp;
            {t('common.loading')}
        </div>}
        {error && <div className='error'>
            <Icon icon={faExclamationTriangle}/>&nbsp;
            {error}
        </div>}
    </div>);

    return (
        <div>
            <h1>{t('country.title_list')}</h1>
            <ul className='CountryList'>
            {data?.countries?.map(c => (
                <CountryItem
                    key={c.code.alpha2}
                    alpha2={c.code.alpha2}
                    alpha3={c.code.alpha3}
                    name_ru={c.name.ru}
                    name_en={c.name.en}
                />
            ))}
            </ul>
        </div>
    );
};

export default CountryList;
